module.exports = __webpack_public_path__ + "static/media/thumb.34818747.jpg";